import { pageView as pageViewEcomm } from "@magalu/ecomm-components/rave/events/GA/pageView";
import dataLayerPush, {
  DataLayerListenerArgs,
} from "@magalu/ecomm-components/rave/events/GA/utils/dataLayerPush";

import {
  COOKIE_CUSTOMER_SESSION_ID,
  COOKIE_CUSTOMER_INFO,
  GA_COOKIE,
  FBC_COOKIE,
  FBP_COOKIE,
  ZIPCODE,
  ZIPCODE_CITY,
  ZIPCODE_STATE,
} from "@utils/constants/cookies";
import { VIRTUAL_PAGEVIEW } from "@utils/constants/events-type";
import { getCityUf } from "@utils/getCityUf/getCityUf";

type PageViewProps = {
  eventId?: string;
  globalData: DataLayerListenerArgs<unknown>;
  value?: {
    quantity_cards?: string;
    default_card?: string;
  };
};

export const pageView = ({ globalData, value }: PageViewProps) => {
  const routeId = globalData?.route?.id || "";
  if (routeId === "identificacao") {
    return pageViewIdentification({ globalData });
  }
  return pageViewEcomm({ globalData, value });
};

export const pageViewCards = ({ globalData, value }: PageViewProps) => {
  const promoterId = globalData?.query?.promoter_id || undefined;
  const cookies = globalData.cookies || {};
  const customerSessionId =
    (cookies[COOKIE_CUSTOMER_SESSION_ID] as string) || "";
  const customerCookieInfo = (cookies[COOKIE_CUSTOMER_INFO] as string) || "";
  const customerId = customerSessionId || customerCookieInfo || undefined;
  const location = {
    zipCode: cookies[ZIPCODE],
    zipCodeCity: cookies[ZIPCODE_CITY],
    zipCodeState: cookies[ZIPCODE_STATE],
  };

  return dataLayerPush(() => ({
    barraLocalizacao: undefined,
    cartaoPadrao: value?.default_card || undefined,
    cepPreenchido: location.zipCode ? "1" : "0",
    cidadeuf: getCityUf(location.zipCodeCity, location.zipCodeState),
    event: VIRTUAL_PAGEVIEW,
    idUsuario: customerId || undefined,
    loginAtivo: customerId ? "logado" : "nao-logado",
    mundos: "magalu",
    pageType: globalData?.route?.name,
    promoter_id: promoterId || undefined,
    quantidadeCartoes: value?.quantity_cards || undefined,
    screenName: globalData?.route?.name || undefined,
  }))({ globalData });
};

export const pageViewIdentification = ({ globalData }: PageViewProps) => {
  const promoterId = globalData?.query?.promoter_id || undefined;
  const cookies = globalData.cookies || {};
  const customerSessionId =
    (cookies[COOKIE_CUSTOMER_SESSION_ID] as string) || "";
  const customerCookieInfo = (cookies[COOKIE_CUSTOMER_INFO] as string) || "";
  const customerId = customerSessionId || customerCookieInfo || undefined;
  const location = {
    zipCode: cookies[ZIPCODE],
    zipCodeCity: cookies[ZIPCODE_CITY],
    zipCodeState: cookies[ZIPCODE_STATE],
  };
  const cookieGA = cookies[GA_COOKIE] || undefined;
  const cookieFBC = cookies[FBC_COOKIE] || undefined;
  const cookieFBP = cookies[FBP_COOKIE] || undefined;

  return dataLayerPush(() => ({
    barraLocalizacao: undefined,
    cepPreenchido: location.zipCode ? "1" : "0",
    cidadeuf: getCityUf(location.zipCodeCity, location.zipCodeState),
    clientId: cookieGA,
    event: VIRTUAL_PAGEVIEW,
    fbc: cookieFBC,
    fbp: cookieFBP,
    idUsuario: customerId || undefined,
    influencer_id: undefined,
    influencer_name: undefined,
    loginAtivo: customerId ? "logado" : "nao-logado",
    pageType: globalData?.route?.name,
    promoter_id: promoterId || undefined,
    screenName: globalData?.route?.name || undefined,
  }))({ globalData });
};
